const serviceJobSortOptions = {
  lastUpload: {
    key: 'resourceLastUploadedAt',
    label: 'Last Upload',
  },
  serviceDate: {
    key: 'dateService',
    label: 'Service Date',
  },
}

export default serviceJobSortOptions
